import { useSelector } from "react-redux";
import { Routes, Route, Navigate } from "react-router-dom";

import VisitScheduleSection from "./sections/visitScheduleSection";
import { IUserOptions } from "../../types/interfaces";

function VisitScheduleApp() {
  const { data } = useSelector((state: IUserOptions) => state.user.user);

  return (
    <Routes>
      {data.isCustomer && data.settings.visitSchedule ? (
        <Route path="/" element={<VisitScheduleSection />} />
      ) :
        <Route path="*" element={<Navigate to="/page404" replace />} />
      }
      {(!data.isCustomer && (data.claims?.length && (data.claims.includes('admin') || data.claims.includes('schedule:list')))) ? (
        <Route path="/" element={<VisitScheduleSection />} />
      ) :
        <Route path="*" element={<Navigate to="/page404" replace />} />
      }
    </Routes>
  );
}

export default VisitScheduleApp;
